import { OwnershipType } from '../model/types';

export const ownershipValueToTitle: Record<OwnershipType, string> = {
  INDIVIDUAL: 'Sole proprietor',
  PARTNERSHIP: 'Partnership',
  CORPORATION: 'Corporation',
};
